export const DISTRIBUICAO_FORM_ID = "distribuicao-form";

export const TITULO_NOVA = "Nova distribuição";
export const TITULO_EDICAO = "Editar distribuição";

export const NOME_LABEL = "Nome da distribuição";
export const NOME_MAX = 80;
export const NOME_NOTA_EDICAO =
  "O nome não pode ser alterado. Para outro nome, crie uma nova distribuição.";
export const NOME_OBRIGATORIO = "Informe o nome da distribuição.";
export const NOME_MUITO_LONGO = `O nome pode ter até ${NOME_MAX} caracteres.`;
export const NOME_REPETIDO = "Já existe uma distribuição com esse nome.";

export const TIPO_LABEL = "Tipo de Obra";
export const TIPO_PLACEHOLDER = "Selecione";
export const TIPO_OBRIGATORIO = "Selecione o Tipo de Obra.";
export const TIPO_CARREGANDO = "Carregando Tipos de Obra...";
export const SEM_TIPO_AVISO = "Selecione o Tipo de Obra para ver os coletores da distribuição.";
export const COLETORES_CARREGANDO = "Carregando coletores...";

export const SOMA_ALVO = 100;
export const PERCENTUAL_FIXO = 100;
export const PERCENTUAL_INVALIDO = "O percentual deve estar entre 0 e 100.";

export const FACILIDADES_TITULO = "Facilidades";
export const FACILIDADES_NOTA = "Fixo: Facilidades vai sempre 100% para o coletor K.";

export const SALVAR_SOMA_INVALIDA = "Ajuste os percentuais até a soma de cada bloco chegar a 100%.";
export const SALVAR_INDISPONIVEL = "Aguarde o carregamento dos coletores.";

export const usoTexto = (escopos: number, obras: number) =>
  `Esta distribuição é usada em ${escopos} ${escopos === 1 ? "escopo macro" : "escopos macro"} de ${obras} ${obras === 1 ? "obra" : "obras"}. Editar os percentuais não recalcula as projeções já gravadas.`;

export const PARTE_TITULO = { MATERIAIS: "Materiais", SERVICOS: "Serviços" } as const;
